module.exports = __webpack_public_path__ + "static/media/load.9ace5331.gif";